<template>
    <section class="container">
        <div class="row">
            <div class="col-sm-12" :class="subActual===listaPasos.pasos[4].titulo ? 'col-md-8' : 'col-md-6'">
                <div v-if="subActual===listaPasos.pasos[0].titulo">
                    <select v-model="anio" class="custom-select form-control">
                        <option :key="item.ndt1" :value="item.ndt1" v-for="item in anios">{{item.ndt1}}</option>
                    </select>
                </div>
                <fade-transition origin="center" mode="out-in" :duration="350">
                    <imagen :cargando="cargandoImg" :activo360="false"
                            :activar="subActual===listaPasos.pasos[4].titulo"/>
                </fade-transition>
                <div v-if="subActual===listaPasos.pasos[2].titulo && comparacion.length>1 && !cargandoImg"
                     class="btn-abajo">
                    <button class="btn btn-block btn-outline-primary" type="button" v-b-modal.comparacion>
                        Compara precio con versiones Similares
                    </button>
                    <comparacion :comparacion="comparacion" :actual="formulario.paquete"
                                 v-on:cambio="cambioComparacion"/>
                </div>
            </div>
            <div class="col-sm-12" :class="subActual===listaPasos.pasos[4].titulo ? 'col-md-4' : 'col-md-6'">
                <fade-transition origin="center" mode="out-in" :duration="350" class="todo">
                    <especificaciones
                            :cargando="cargando"
                            v-if="subActual===listaPasos.pasos[0].titulo"
                            :version="formulario.version"
                            :modelo="modelo"
                            v-model="formulario.terminos"/>
                    <potencia
                            :cargando="cargando"
                            v-if="subActual===listaPasos.pasos[1].titulo"
                            :version="formulario.version"
                            v-model="formulario.potencia"
                            :estadoBtn="cargandoPaq"
                            :paquetes="paquetes"/>
                    <paquetes
                            :cargando="cargandoPaq"
                            v-if="subActual===listaPasos.pasos[2].titulo"
                            :version="formulario.version"
                            v-model="formulario.paquete"
                            :paquetes="paquetes"
                            :estadoBtn="cargandoAcc"
                            :comparacion="comparacion"
                    />
                    <accesorios
                            :cargando="cargandoAcc"
                            :individuales="accesorios"
                            :kits="kits"
                            :cupones="prepagados"
                            v-model="formulario.accesorios"
                            v-if="subActual===listaPasos.pasos[3].titulo"/>
                    <exterior
                            :cargando="cargando"
                            v-if="subActual===listaPasos.pasos[4].titulo"
                            :version="formulario.version"
                            v-model="formulario.color"
                            :numAc="kits.length+accesorios.length"
                    />
                </fade-transition>
            </div>
        </div>
    </section>
</template>

<script>
    import {FadeTransition} from "vue2-transitions";

    import imagen from "./Imagen/imagen-vehiculo"
    import especificaciones from "./Especificaciones/especificaciones";
    import potencia from "./Potencia/potencia";
    import paquetes from "./Paquetes/paquetes";

    import * as servicios from "../../servicios";
    import constantes from "../../constantes";
    import Exterior from "./Exterior/exterior";
    import Accesorios from "./Accesorios/acesorios";
    import comparacion from "../../componentes/comparacion";

    export default {
        name: "main-paso2",
        components: {
            Exterior,
            FadeTransition,
            imagen,
            especificaciones,
            potencia,
            paquetes,
            Accesorios,
            comparacion
        },
        data: () => ({
            cargando: true,
            cargandoImg: true,
            cargandoPaq: false,
            cargandoAcc: true,
            listaPasos: constantes.Constantes.pasos[1],
            modelo: {},
            paquetes: [],
            accesorios: [],
            kits: [],
            prepagados: [],
            comparacion: [],
            anio: null,
            clase: 'logo-version',
        }),
        computed: {
            subActual: function () {
                return this.$store.getters.getSubActual;
            },
            anios: function () {
                return this.$store.getters.getPasos[1].modelo.elements;
            },
            formulario: {
                get: function () {
                    return this.$store.getters.getPasos[2];
                },
                set: function (newValue) {
                    this.$store.commit('setPaso', {p: "2", data: newValue});
                }
            }
        },
        watch: {
            modelo: {
                handler() {
                    this.consultarVersion();
                },
                deep: true,
            },
            "formulario.accesorios.kit": {
                handler(nuevo) {
                    this.buscarEnIndividuales(nuevo);
                    this.kitDuplicado(nuevo);
                },
                deep: true
            },
            "formulario.potencia": {
                handler() {
                    this.consultarPaquetes();
                },
                deep: true
            },
            "formulario.paquete": {
                handler(valor) {
                    if (valor)
                        if (valor.id) {
                            this.consultaPaquetesComparacion();
                        }
                },
                deep: true
            },
            "formulario.paquete.id": {
                handler() {
                    this.consultarResumen();
                },
                deep: true
            },
            async anio(nuevo, anterior) {
                if (anterior) {
                    this.$store.commit('setPrecio', 0);
                    await this.consultarVersion(nuevo);
                    this.consultarPaquetes();
                }
            }
        },
        methods: {
            cambioComparacion: function (paquete) {
                this.formulario.potencia.motor.id = paquete.ndt8;
                this.formulario.potencia.transmision.id = paquete.ndt7;
                this.formulario.potencia.traccion.id = paquete.ndt6;
                this.formulario.version.ndt10 = paquete.ndt9;
                this.formulario.paquete = paquete;
                this.anio = paquete.ndt9;
                this.consultarPaquetes();
            },
            sinModelo: function () {
                this.cargando = true;
                this.cargandoImg = true;
                const aux = this.$store.getters.getPasos["1"].provincia
                this.$store.commit('setActual', 2);
                this.$store.commit('setSubActual', 0);
                servicios.modelos.idmodelo(this.$route.params.id).then(response => {
                    this.modelo = response.data;
                    let formulario = {
                        modelo: response.data,
                        provincia: aux,
                    };
                    this.$store.commit('setPaso', {data: formulario, p: 1});
                    this.cargando = false;
                    this.cargandoImg = false;
                }).catch(() => {
                    this.$router.push({name: 'p1'});
                });
            },
            async consultarVersion(anio) {
                this.cargando = true;
                this.cargandoImg = true;
                await servicios.modelos.idVersionComercial(this.modelo, anio).then(response => {
                    this.anio = response.data.ndt10;
                    this.formulario.version = response.data;
                    this.$store.commit('setPrecio', this.formulario.version.ndt6);
                    this.cargando = false;
                    this.cargandoImg = false;
                });
            },
            consultaPaquetesComparacion: function () {
                servicios.paquetes.comparacionPaquete(this.formulario.paquete).then(r => r.data).then(response => {
                    this.comparacion = response;
                });
            },
            consultarPaquetes: function () {
                if (this.formulario.potencia.motor.id !== null && this.formulario.potencia.transmision.id !== null) {
                    this.cargandoPaq = true;
                    servicios.paquetes.paquetesVersionComercial(this.formulario).then(response => {
                        this.paquetes = response.data;
                        try {
                            const aux = this.paquetes.find(i => i.id === this.formulario.paquete.id);
                            if (aux)
                                this.formulario.paquete = aux;
                            else
                                this.formulario.paquete = this.paquetes[0];
                        } catch (e) {
                            this.formulario.paquete = this.paquetes[0];
                        }
                        this.cargandoPaq = false;
                    });
                }
            },
            async consultarAccesorios() {
                if (this.formulario.paquete.id !== null) {
                    if (this.$store.getters.getSubActual === "Paquetes") {
                        this.formulario.accesorios.individuales = [];
                        this.formulario.accesorios.kit = [];
                    }
                    this.cargandoAcc = true;
                    const [
                        individuales,
                        kit,
                        cupones
                    ] = await servicios.accesorios.todos(this.formulario.paquete);
                    this.accesorios = individuales.data;
                    this.kits = kit.data;
                    this.prepagados = cupones.data;
                    this.cargandoAcc = false;
                }
            },
            consultarResumen: function () {
                if (this.formulario.paquete) {
                    this.consultarAccesorios();
                    servicios.paquetes.resumenPaquete(this.formulario).then(response => {
                        let formulario = {resumen: response.data, total: constantes.funciones.sumar(response.data)};
                        this.$store.commit('setPaso', {data: formulario, p: 3});
                        this.$store.commit('setPrecio', constantes.funciones.sumar(response.data));
                    });
                }
            },
            buscarEnIndividuales: function (kit) {
                this.accesorios.forEach(item => {
                    item.bdt9 = false;
                });
                kit.forEach((item) => {
                    if (item.elements) {
                        item.elements.forEach((item2) => {
                            this.desactivarAccesorio(item2, this.accesorios, this.formulario.accesorios.individuales);
                        });
                    }
                });
            },
            kitDuplicado: function (kit) {
                this.kits.forEach(item => {
                    item.bdt9 = false;
                });
                if (kit.length) {
                    kit.forEach(ultimo => {
                        this.kits.forEach(item => {
                            if (ultimo.ndt1 !== item.ndt1) {
                                if (item.elements) {
                                    item.elements.forEach(item2 => {
                                        if (ultimo.elements) {
                                            ultimo.elements.forEach(item3 => {
                                                if (item2.ndt1 === item3.ndt1)
                                                    item.bdt9 = true;
                                            });
                                        }
                                    });
                                }
                            }
                        });
                    });
                }
            },
            desactivarAccesorio: function (codigo, accesorios, seleccionados) {
                const indice = accesorios.findIndex(x => x.ndt1 === codigo.ndt1);
                if (indice >= 0)
                    accesorios[indice].bdt9 = true;
                const indice2 = seleccionados.findIndex(x => x.ndt1 === codigo.ndt1);
                if (indice2 >= 0) {
                    this.$toast.show(`Se ha removido ${seleccionados[indice2].dt2} porque ${codigo.dt2} ya lo incluye`);
                    seleccionados.splice(indice2, 1);
                }
            }
        },
        created() {
            this.sinModelo();
            ///this.$store.commit('limpiarSub');
        },
        mounted() {
            this.$analytics.fbq.event('track', 'ViewContent');
        }
    }
</script>

<style scoped>
    .sin {
        visibility: hidden;
    }

    .btn-abajo {
        position: absolute;
        width: 95%;
        bottom: 0;
    }
</style>
